// import DefaultLegacyImport from '@elliemae/ds-legacy-toolbar';
// export { DSToolbar, ToolbarItem, ToolbarGroup, ToolbarDivider, ToolbarWithSchema } from '@elliemae/ds-legacy-toolbar';
// export default DefaultLegacyImport;

export * from '@elliemae/ds-legacy-toolbar';
